// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IAuditLogSummary {
	id: string | undefined;

	timestamp: string | undefined;

	httpMethod: string | undefined;

	endpoint: string | undefined;

	controllerName: string | undefined;

	actionName: string | undefined;

	payload: string | undefined;

	userId: string | undefined;

	userName: string | undefined;

	responseStatusCode: number;

	isSuccess: boolean;

	errorMessage: string | undefined;

	executionTimeMs: number;

	traceId: string | undefined;

	$type?: string | undefined;
}
export class AuditLogSummary {
	constructor(data?: IAuditLogSummary) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.timestamp) { this.timestamp = new Date(data.timestamp); }
	}

	id: string | undefined;

	timestamp: Date | undefined = new Date();

	httpMethod: string | undefined;

	endpoint: string | undefined;

	controllerName: string | undefined;

	actionName: string | undefined;

	payload: string | undefined;

	userId: string | undefined;

	userName: string | undefined;

	responseStatusCode: number = 0;

	isSuccess: boolean = false;

	errorMessage: string | undefined;

	executionTimeMs: number = 0;

	traceId: string | undefined;

	static $type: string = "CoreApi.Models.AuditLogs.AuditLogSummary, ";
	$type?: string | undefined = AuditLogSummary.$type;
}

